import React, { useContext, useEffect } from "react";

// import "../PAlauncher.css";

import {
  InputCopy,
  FormGroup,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Subheader,
  Head,
  Card,
  Input,
  RadioGroup,
  Switch,
  ButtonAction,
  Tag,
  Notification
} from "xsolla-uikit";

import CardNew from "../PAcardNew";
import PAh2 from "../PAh2";

import { CssChartsGrid } from "./../uikit2";

import {
  PAchart1,
  PAloginUsersFake,
  PAchart2fake,
  PAchartMap
} from "../PAcharts";
import {
  PAlogin0fake,
  PAloginSocialfake,


  PAchart1fake,
  PAchart2
} from "../PAchart2";

import { PAchartUsersMethods, PAchartUsersTime, PAchartUsersMap } from './../dashboard/PAchartUsersMethods';
import { PaChartCard } from "../uikit2/PaChartCard";
import { CSSchartfix } from "../PAdashboard";

export default function PAloginStats({charts = [
  'time',
  'methods',
]}) {
  return (
    <FormGroup indentation="xs">
<CSSchartfix>

      {/* <FormGroup indentation="lg"> */}
        <CssChartsGrid>
          {charts.indexOf('time') > -1 && <div style={{ minWidth: "200px" }}>

          <PaChartCard title={<PAh2 tag="h3" title='Users over time' indentation="xs"/>}>
            <PAchartUsersTime />
          </PaChartCard>

          </div>}

          {charts.indexOf('methods') > -1 && <div style={{ minWidth: "200px" }}>
            <PaChartCard title={<PAh2 tag="h3" title='Authentication methods' indentation="xs"/>} >

                    <PAchartUsersMethods />

                  </PaChartCard>
        </div>}

        {charts.indexOf('country') > -1 &&
          <PaChartCard title="Users by country" cols={2}>
            <PAchartMap/>
            {/* <PAchartUsersMap/> */}
            {/* <PAchart2fake /> */}
          </PaChartCard>
        }

        </CssChartsGrid>
      {/* </FormGroup> */}



</CSSchartfix>
    </FormGroup>
  );
}


